export const initialState = () => ({
  loading: {
    show: false,
    message: ""
  },
  question: "",
  questionType: "",
  isFromBiometry: false,
  skipBiometry: false,
  orderDate: "",
  orderCode: "",
  uuidBiometry: null,
  uuidOrder: null,
  token: null
})
